import { Handle, Position } from 'reactflow';
import styles from '../styles/nodes.module.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faX } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';

export default function TimerNode({ id, data }) {
    const { t } = useTranslation();
    const [minutes, setMinutes] = useState(data.value_2 || 5);
    const [triggerOn, setTriggerOn] = useState(data.timer_trigger_on ?? 1);

    useEffect(() => {
        setMinutes(data.value_2 || 5);
        setTriggerOn(data.timer_trigger_on ?? 1);
    }, [data]);

    const handleMinutesChange = (event) => {
        const val = event.target.value;
        if (val === '' || /^\d+$/.test(val)) {
            setMinutes(val);
            data.value_2 = val;
        }
    };

    const handleTriggerOnChange = (event) => {
        const val = parseInt(event.target.value);
        setTriggerOn(val);
        data.timer_trigger_on = val;
    };

    return (
        <div className={`${styles.scratch_block_timer} shadow`}>
            <Handle type="target" position={Position.Top} id={"i1" + id} style={{ left: '50%' }} />

            <div className="d-flex flex-row w-100 justify-content-between">
                <div className={'d-flex'}>
                    <div className={styles.scratch_block_type_icon_timer}>
                        <FontAwesomeIcon icon={faClock} color="white" />
                    </div>
                    <div className={styles.scratch_block_type}>{t('operations.nodes.timer')}</div>
                </div>
                <div className={'px-2 pointer-event'} onClick={() => {
                    if (typeof data.onDeleteNode === 'function') {
                        data.onDeleteNode(id);
                    } else {
                        data.setNodes((prev) => [...prev.filter((node) => node.id !== id)]);
                        data.setDeletionList((prev) => [...prev, id]);
                    }
                }}>
                    <FontAwesomeIcon icon={faX} color={'#999'} size={'sm'} />
                </div>
            </div>

            {data.is_connected_1 ? (
                <div className={styles.scratch_label} style={{ color: '#92400E' }}>{data.value_1}</div>
            ) : (
                <div style={{ fontSize: '11px', color: '#B45309', fontStyle: 'italic', margin: '8px 0' }}>
                    {t('operations.nodes.connectBooleanAbove')}
                </div>
            )}

            <div style={{ fontSize: '12px', color: '#92400E', margin: '4px 0' }}>
                {t('operations.nodes.whenInputIs')}
            </div>

            <select
                className={`${styles.scratch_select} nodrag`}
                onChange={handleTriggerOnChange}
                value={triggerOn}
                style={{ width: '100%', marginBottom: '6px' }}
            >
                <option value={1}>{t('operations.nodes.trueOne')}</option>
                <option value={0}>{t('operations.nodes.falseZero')}</option>
            </select>

            <div style={{ fontSize: '12px', color: '#92400E', margin: '4px 0' }}>
                {t('operations.nodes.forLabel')}
            </div>

            <div className="d-flex align-items-center w-100" style={{ gap: '8px' }}>
                <input
                    className={`${styles.scratch_input} nodrag`}
                    type="text"
                    inputMode="numeric"
                    onChange={handleMinutesChange}
                    value={minutes}
                    style={{ width: '70px', textAlign: 'center' }}
                />
                <span style={{ fontSize: '13px', color: '#92400E' }}>{t('operations.nodes.minutes')}</span>
            </div>

            <div style={{ fontSize: '11px', color: '#92400E', marginTop: '8px' }}>
                {t('operations.nodes.thenTriggerBelow')}
            </div>

            <Handle type="source" position={Position.Bottom} id="out" />
        </div>
    );
}
